/***********************************************************************
 An instance of this class handles multiple sco's and act to the LMS
 as a single SCO with the given Scorm 1.2 API.
 The stored data will be saved compresses and encrypted in the
 suspend data field on LMS.
 ***********************************************************************/
import {ScormCourse} from "scorm/scorm_1_2/ScormCourse";
import {CreScormApi} from "scorm/scorm_1_2/cre/CreScormApi";
import {InactiveCreScormApi} from "scorm/scorm_1_2/cre/InactiveCreScormApi";
import {Event} from "common/Event";
import {CourseEvents} from "course/CourseEvents";
import {ActiveSco} from "scorm/common/ActiveSco";
import {Assert} from "common/Assert";

export function ScormDelegateApi( lmsScormApi, masteryScore ) {

    Assert.checkArgument( lmsScormApi );
    const course = new ScormCourse( lmsScormApi, masteryScore ),
          activeSco = new ActiveSco(),
          apiType = "scorm12";

    let creScormApi = new InactiveCreScormApi();
    Event.on( document, CourseEvents.SEQUENCE_TERMINATED, afterScoTerminate );


    /***********************************************************************
     * prepares the scorm api for the ttkf player with a specific sco id
     * @param {String} scoId the id of the sco
     * @return {String} 'false' if a sco is already acitve, otherwise 'true'
     ***********************************************************************/
    function beforeScoLaunch( scoId ) {

        if( activeSco.get() || !scoId ) {
            return "false";
        }

        activeSco.set( scoId );
        const sco = course.initializeSco( scoId );
        creScormApi = new CreScormApi( sco, course.getCreApi() );

        return "true";
    }

    /***********************************************************************
     * shuts down the scorm api for the ttkf player
     ***********************************************************************/
    function afterScoTerminate( event, data ) {

        if( !activeSco.isAvailable() || activeSco.get() !== data.scoId ) {
            console.log("ScormDelegateApi::afterScoTerminate isSCOActive=false");
            return;
        }

        activeSco.clear();
        creScormApi = new InactiveCreScormApi();
        console.log("ScormDelegateApi::afterScoTerminate isSCOActive=true");
    }

    /***********************************************************************
     * checks, if the scorm api has a active sco id
     * @return {String} true / false
     ***********************************************************************/
    function TTSCOIsInUse() {
        console.log("ScormDelegateApi::TTSCOIsInUse: " + activeSco.isAvailable().toString());
        return activeSco.isAvailable().toString();
    }

    /***********************************************************************
     * checks, if the scorm api has a active sco id
     * @return {String} true / false
     ***********************************************************************/
    function TTInitialize() {
        return activeSco.isAvailable() ? "false" : "true";
    }

    /***********************************************************************
     * terminates the communication to the lms api and and clears the active
     * sco id
     * @return {String} true / false
     ***********************************************************************/
    function TTTerminate() {
        console.log("ScormDelegateApi::TTTerminate");
        activeSco.clear();
        return course.terminate();
    }

    /***********************************************************************
     * gets the api type
     * @return {String} scorm12
     ***********************************************************************/
    function TTGetApiType() {
        return apiType;
    }

    /***********************************************************************
     * this function can be called from a SCO to start the following SCO.
     * @return {String}
     ***********************************************************************/
    function TTNavigateForward() {
        if (typeof(window.onTTNavigateForward) !== "undefined") {
            return window.onTTNavigateForward();
        }
        return "false";
    }

    /***********************************************************************
     * this function can be called from a SCO to show the "table of content".
     * @return {String}
     ***********************************************************************/
    function TTOpenTOC() {
        if (typeof(window.onTTOpenTOC) !== "undefined") {
            return window.onTTOpenTOC();
        }
        return "false";
    }

    // revealing public api
    return {

        /*********************************************************************
         *  api methods
         *  this calls have to be wrapped by a function body, because we change
         *  the instance of creScormApi on runtime
         ********************************************************************/
        LMSInitialize: ( param ) => { return creScormApi.LMSInitialize( param ); },
        LMSFinish: ( param ) => { return creScormApi.LMSFinish( param ); },
        LMSGetValue: ( key ) => { return creScormApi.LMSGetValue( key ); },
        LMSSetValue: ( key, value ) => { return creScormApi.LMSSetValue( key, value ); },
        LMSCommit: ( param ) => { return creScormApi.LMSCommit( param ); },
        LMSGetLastError: () => { return creScormApi.LMSGetLastError(); },
        LMSGetErrorString: ( errorCode ) => { return creScormApi.LMSGetErrorString( errorCode ); },
        LMSGetDiagnostic: ( errorCode ) => { return creScormApi.LMSGetDiagnostic( errorCode ); },

        /*********************************************************************
         *  custom api methods
         ********************************************************************/

        TTNavigateForward: TTNavigateForward,
        TTOpenTOC: TTOpenTOC,

        TTSCOIsInUse: TTSCOIsInUse,
        TTPrepareScoLaunch: beforeScoLaunch,
        TTInitialize: TTInitialize,
        TTTerminate: TTTerminate,
        TTGetApiType: TTGetApiType,
        TTIsDelegateApi: () => "true",

        TTInitializeApi: course.initialize,
        TTGetCourseMasteryScore: course.getMasteryScore,
        TTGetCompletionThreshold: course.getCompletionThreshold,
        TTCommit: course.commit,
        TTSetScoreList: course.setScoreList,
        TTGetValue: course.getValue,
        TTGetCourseValue: course.getCourseValue,

        /*********************************************************************
         * @deprecated does nothing useful
         ********************************************************************/
        TTSetScoInfo: () => "true",
    };
}
